(ns frontend.ui.component.modal-dialog.view
  (:require
   [frontend.ui.component.icon.view :refer [icon]]
   [ui.components.button.view :as button]
   [frontend.ui.component.modal-dialog.style :as style]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [common.localization :as loc]
   [frontend.utils :as fu]))

(defn- header
  [{:keys [header-label hide!]}]
  [:div
   {:class (<class style/header)}
   header-label
   [:a
    {:on-click hide!}
    [icon :times]]])

(defn- body
  [props child]
  (let [body-style-override (get-in props [:style :body])]
    [:div
     {:class (<class style/body body-style-override)}
     child]))

(defn- footer
  [child]
  [:div
   {:class (<class style/footer)}
   child])

(defn- modal-content
  [props body-child footer-child]
  [:div
   {:class (<class style/modal-dimmer)}
   [:div
    {:class (<class style/modal-content props)}
    [:div
     {:class (<class style/modal-inner)}
     [header props]
     [body
      props
      body-child]
     (when footer-child
       [footer
        footer-child])]]])

(defn- modal-div
  [style-fn on-click]
  [:div
   {:class    (<class style-fn)
    :on-click (fn [e]
                (fu/stop-propagation-event! e)
                (when (fn? on-click)
                  (on-click e)))}])

(defn modal-dialog
  "Return a modal components accepting:
   - `props` (use `./core.cljs` to generate the state part of this)
   - `body-child`: body of the modal
   - `footer-child`: optional footer of the modal

   If you need more than one component for body or footer, wrap them in a `div`."
  ;; To close the modal when user clicks out of it, we could use
  ;; `stopPropagation` but it looks rather controversial [0] and not without
  ;; consequences. Instead, in this component, we declare four transparent
  ;; components (North/West/East/South) on which we are able to detect a click.
  ;; [0]:
  ;; https://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element
  [{:keys [visible? size hide! backdrop header-label] :as props}
   body-child
   footer-child]
  [:div
   {:class (<class style/modal visible?)}
   [modal-content
    props
    body-child
    footer-child]])

(defn confirm-dialog
  [{:keys [visible? hide confirm-text ok-button-text cancel-button-text
           on-confirm on-cancel]
    :as   props}]
  [modal-dialog
   (assoc props :backdrop "static")
   [:div
    {:class (<class common-style/spacing-top-bottom)}
    confirm-text]
   [:div
    {:class (<class common-style/footer-right)}
    [:div
     {:class (<class common-style/spacing-left)}
     [button/primary-solid
      {:on-click on-confirm}
      (or ok-button-text
          (loc/tr :confirm))]]
    [:div
     {:class (<class common-style/spacing-left)}
     [button/secondary-hollow
      {:on-click on-cancel}
      (or cancel-button-text
          (loc/tr :cancel))]]]])
